function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

function encodeVisitorRecordString(value) {
  try {
    return encodeURIComponent(decodeURIComponent(value))
  } catch (e) {
    return encodeURIComponent(value)
  }
}

function encodeVisitorRecordValue(value) {
  if (typeof value === 'string') {
    return encodeVisitorRecordString(value)
  }

  if (Array.isArray(value)) {
    return value.map((item) => encodeVisitorRecordValue(item))
  }

  if (value && isPlainObject(value)) {
    return encodeVisitorRecordParams(value)
  }

  return value
}

export function encodeVisitorRecordParams(params) {
  if (!params || !isPlainObject(params)) {
    return params
  }

  return Object.keys(params).reduce((result, key) => {
    result[key] = key === 'fromType' ? params[key] : encodeVisitorRecordValue(params[key])
    return result
  }, {})
}

export const encodeVisitLogParams = encodeVisitorRecordParams



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/common/visitorRecord.js